import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getBrandProducts, clearErrors } from '../../actions/brandAction';
import Product from './Product';
import Loader from '../Layouts/Loader';
import { useSnackbar } from 'notistack';
import { Box, Typography, Grid, Paper, Tabs, Tab, Avatar } from '@mui/material';
import MetaData from '../Layouts/MetaData';

const BrandProducts = () => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { id } = useParams();

    const { loading, brand, products, error } = useSelector((state) => state.brandProducts);

    const [selectedCategory, setSelectedCategory] = useState('All');
    const [categories, setCategories] = useState(['All']);

    useEffect(() => {
        if (products) {
            setCategories(['All', ...new Set(products.map((p) => p.category.name))]);
        }
    }, [products]);

    console.log('Products:', products);
    console.log('Categories:', categories);

    const filteredProducts =
        selectedCategory === 'All'
            ? products
            : products.filter((p) => p.category.name === selectedCategory);

    useEffect(() => {
        if (error) {
            enqueueSnackbar(error, { variant: 'error' });
            dispatch(clearErrors());
        }
        dispatch(getBrandProducts(id));
    }, [dispatch, enqueueSnackbar, error, id]);

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <>
                    {brand && <MetaData title={`${brand.name} - AmritLok`} />}
                    <Box sx={{ width: '100%' }}>
                        <Paper
                            elevation={1}
                            sx={{
                                height: { xs: '150px', sm: '200px' },
                                background: 'linear-gradient(to right, #dae2f8, #d6a4a4)',
                                mb: 2,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {brand && brand.logo && (
                                <img
                                    src={brand.logo.url}
                                    alt={brand.name}
                                    style={{
                                        height: 'clamp(80px, 100%, 120px)',
                                        objectFit: 'contain',
                                    }}
                                />
                            )}
                        </Paper>
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2, bgcolor: 'background.paper' }}>
                            <Typography
                                variant="h4"
                                component="h1"
                                sx={{
                                    fontWeight: 'bold',
                                    fontSize: { xs: '1.8rem', sm: '2.125rem' },
                                }}
                            >
                                {brand && brand.name}
                            </Typography>
                        </Box>
                        <Tabs
                            value={selectedCategory}
                            onChange={(event, newValue) => setSelectedCategory(newValue)}
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"
                            sx={{
                                '& .MuiTabs-flexContainer': {
                                    justifyContent: 'center',
                                },
                            }}
                        >
                            {categories.map((category) => (
                                <Tab label={category} value={category} key={category} />
                            ))}
                        </Tabs>

                        <Box sx={{ p: 2 }}>
                            <Grid container spacing={2}>
                                {filteredProducts &&
                                    filteredProducts.map((product) => (
                                        <Grid item xs={12} sm={6} md={4} lg={3} key={product._id}>
                                            <Product {...product} />
                                        </Grid>
                                    ))}
                            </Grid>
                        </Box>
                    </Box>
                </>
            )}
        </>
    );
};

export default BrandProducts;